import { render, staticRenderFns } from "./TermsLayout.vue?vue&type=template&id=07633ab6&"
import script from "./TermsLayout.vue?vue&type=script&lang=js&"
export * from "./TermsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports